<template>
  <RadarChart
    class="mandala-evaluations-radar-chart"
    :labels="labels"
    :display-legend="displayLegend"
    :styles="styles"
    :datasets="chartData"
    :padding="padding"
    :width="400"
    :height="400"
    :device-pixel-ratio="devicePixelRatio" />
</template>

<script>
import RadarChart from '@/components/charts/RadarChart.vue'
import { format } from 'date-fns'
export default {
  components: {
    RadarChart
  },
  props: {
    mandalaEvaluations: {
      type: Array,
      default: () => []
    },
    yearMonths: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default: () => [
        '#E91E63',
        '#F48FB1',
        '#BDBDBD',
      ]
    },
    displayLegend: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => {}
    },
    padding: {
      type: Object,
      default: () => {}
    },
    devicePixelRatio: {
      type: Number,
      default: null
    },
  },
  computed: {
    // 取得した中で一番新しい自己評価
    latestMandalaEvaluation() {
      return this.mandalaEvaluations[0] || null
    },
    mandalaEvaluationByYearMonth() {
      return this.mandalaEvaluations.reduce((prev, curr) => {
        return { ...prev, [curr.yearMonth]: curr }
      }, {})
    },
    labels() {
      if (!this.latestMandalaEvaluation) {
        // 空の場合でもグラフは表示しておきたいので、空配列を返す
        return ['', '', '', '', '', '', '', '']
      }
      return this.latestMandalaEvaluation.mandalaGoalSelfEvaluationEntries.map(entry => entry.name ? entry.name.slice(0, 4) : '')
    },
    chartData() {
      return this.yearMonths.reduce((prev, curr, index) => {
        const mandalaEvaluation = this.mandalaEvaluationByYearMonth[curr]
        if (!mandalaEvaluation) {
          return prev
        }
        return [...prev, this.generateChartDataFromMandalaEvaluation(mandalaEvaluation, this.colors[index])]
      }, [])
    },
  },
  methods: {
    generateChartDataFromMandalaEvaluation(mandalaEvaluation, color) {
      const { yearMonth, mandalaGoalSelfEvaluationEntries } = mandalaEvaluation
      const label = format(new Date(yearMonth), 'yyyy年M月')

      const data = mandalaGoalSelfEvaluationEntries.map(entry => {
        return entry.mandalaGoalSelfEvaluationActionGoals.reduce((prev, curr) => {
          if (prev === null && curr.score === null) {
            return prev
          }
          return prev + (curr.score || 0)
        }, null)
      })
      return {
        label,
        backgroundColor: color,
        borderColor: color,
        pointBackgroundColor: color,
        pointRadius: 5,
        pointBorderColor: '#fff',
        data,
      }
    },
  }
}
</script>

<style>
.mandala-evaluations-radar-chart {
  canvas {
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    height: auto!important;
    width: auto!important;
  }
}
</style>